module.exports = __webpack_public_path__ + "static/media/02.698819a8.webp";